import moment from "moment";

export const formatearFecha = (fecha) =>
    fecha ? moment(fecha).format("DD/MM/YYYY") : "";

export const formatearFechaHora = (fecha) =>
    fecha ? moment(fecha).format("DD/MM/YYYY HH:mm") : "";
